RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const periodTypeEnums = RivalIQ.enums.timePeriod.periodType;
    const timePeriodDefinitions = RivalIQ.data.timePeriodDefinitions;
    const MAIN_PERIOD_INDEX = 2;

    const customPeriodTypesByPeriod = {};
    customPeriodTypesByPeriod[periodTypeEnums.MAIN_PERIOD] = RivalIQ.enums.timePeriod.mainPeriodType.CUSTOM;
    customPeriodTypesByPeriod[periodTypeEnums.COMPARE_PERIOD] = RivalIQ.enums.timePeriod.comparePeriodType.CUSTOM;

    function renderPeriodOptions(periodMask, selected, options) {
        const maxHistoryDays = RivalIQ.state.account.get('historyLimits').historyLimitDays;

        let enabled = '';
        let disabled = '';
        const isTrialer = RivalIQ.state.account.isTrialing();
        const disabledMsg = isTrialer ? 'Unavailable in Trial' : 'Unavailable';

        options.each(function (period) {
            const selectedVal = (period.id === selected ? 'selected' : '');
            const option = (`<option value="${period.id}" ${selectedVal}>${period.get('name')}</option>`);
            const maxHistoryDaysRequired = period.get('maxHistoryDaysRequired');
            const showDisabledOption = period.get('showDisabledOption') || _.constant(true);

            if (_.isFinite(periodMask) && !(periodMask & period.id)) {
                disabled += option;
                return;
            }

            if (maxHistoryDaysRequired) {
                if (maxHistoryDays > maxHistoryDaysRequired) {
                    enabled += option;
                } else if (showDisabledOption()) {
                    disabled += option;
                }
            } else {
                enabled += option;
            }
        });

        if (disabled) {
            disabled = `<optgroup label="${disabledMsg}" disabled>${disabled}</optgroup>`;
        }

        return enabled + disabled;
    }

    const catchAndReportErrors = function (traceString, fn) {
        try {
            return fn();
        } catch (error) {
            RivalIQ.errors.script.reportError([
                traceString,
                window.location,
                error.message,
                _.result(error, 'stack')
            ].join('; '), error);

            throw error;
        }
    };

    views.TimePeriodPicker = Marionette.ItemView.extend({
        template: '#shellTimePeriodPickerTemplate',
        className: 'time-period-picker-popover popover fade in',
        ui: {
            dateForm: '.date-form',
            dateInput: '.date-input',
            datePicker: '.time-period-calendar-section',
            periodSelector: '.period-selector',
            closeBtn: '.x-close',
            saveBtn: '.x-save',
            warningSection: '.time-period-warning-section',
            warningMessage: '.warning-message',
            mobilePeriods: '.x-mobile-list .x-mobile-list-item',
            timePeriodTzChange: '.time-period-tz-change'
        },
        behaviors: function () {
            const me = this;
            const infoContent = _.get(me.options.dateRangeRestrictions, ['messages', 'notAvailable'], RivalIQ.strings.date_picker_legend_not_available_description);
            return {
                AttributeBuilder: {},
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: {
                        title: RivalIQ.strings.date_picker_legend_not_available_title,
                        content: infoContent
                    }
                }
            };
        },
        events: {
            'click @ui.closeBtn': 'onCloseClick',
            'click @ui.saveBtn': 'onSaveClick',
            'click @ui.mobilePeriods': 'onMobilePeriodChange'
        },
        eventsNotToDebounce: {
            'input @ui.dateInput': 'onDateInputChange',
            'focus @ui.dateInput': 'onDateInputFocus',
            'focusout @ui.dateInput': 'onDateInputFocusout',
            'change select': 'onPeriodTypeChange'
        },

        showWarning: function (message, hasPopover) {
            const me = this;
            me.ui.warningMessage.html(message);
            if (hasPopover) {
                me.ui.warningMessage.find('.rivaliq-popover').popover();
            }
            me.ui.warningSection.removeClass('hidden');
            me.ui.saveBtn.attr('disabled', true);
        },

        hideWarning: function () {
            const me = this;

            const erroredInputs = me.ui.dateForm.filter('.has-error');
            let hasError = false;

            // keep the error style on invalid date formats
            erroredInputs.each(function (i, el) {
                const validDate = me.validateDateInput($(el).find('.date-input'));
                if (validDate) {
                    $(el).removeClass('has-error');
                } else {
                    hasError = true;
                }
            });
            if (!hasError) {
                me.ui.warningSection.addClass('hidden');
                me.ui.saveBtn.attr('disabled', false);
            }
        },

        initialize: function () {
            const me = this;

            me.locale = RivalIQ.utils.timePeriod.getLocale();
            me.localeLongDateFormat = _.get(moment.localeData(me.locale), ['_config', 'longDateFormat', 'L']);
            // NOTE: 'ar' date format doesn't have enough digits
            if (me.localeLongDateFormat === 'D/‏M/‏YYYY') {
                me.localeLongDateFormat = 'DD/MM/YYYY';
            }
        },

        onCloseClick: function () {
            const me = this;
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2Cancel);
            me.close();
        },

        close: function () {
            const me = this;
            me.destroy();
        },

        onSaveClick: function () {
            const me = this;
            const timePeriod = RivalIQ.utils.timePeriod.serializeDates(me.getTimePeriod());
            const comparePeriodId = _.get(timePeriod, ['periods', 1]);
            const mainPeriodId = _.get(timePeriod, ['periods', 2]);
            const mainPeriodDuration = moment(timePeriod.mainPeriodEnd).diff(timePeriod.mainPeriodStart, 'days') + 1;
            const mainPeriodStartDaysAgo = moment().diff(timePeriod.mainPeriodStart, 'days');

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2Apply, {
                comparePeriodId: comparePeriodId,
                mainPeriodId: mainPeriodId,
                mainPeriodDuration: mainPeriodDuration,
                mainPeriodStartDaysAgo: mainPeriodStartDaysAgo
            });

            me.save();
        },

        save: function () {
            const me = this;

            catchAndReportErrors('save', function () {
                const timePeriod = RivalIQ.utils.timePeriod.serializeDates(me.getTimePeriod());

                const attrs = {
                    timePeriod: timePeriod
                };

                if (timePeriod.id === RivalIQ.enums.timePeriod.type.CUSTOM) {
                    attrs.customTimePeriod = timePeriod;
                }

                RivalIQ.state.view.set(attrs);
                me.close();
            });
        },

        onBeforeShow: function () {
            const me = this;

            catchAndReportErrors('onBeforeShow', function () {
                const dateRanges = {};
                _.each([periodTypeEnums.COMPARE_PERIOD, periodTypeEnums.MAIN_PERIOD], function (period) {
                    dateRanges[period] = {
                        minDate: me.calculateMinDate(period),
                        maxDate: me.calculateMaxDate(period)
                    };
                });

                me.datePicker = new views.DatePicker({
                    container: me.ui.datePicker[0],
                    isDisabled: false,
                    minDataDate: me.calculateMinDataDate(),
                    notateMissingData: !_.get(me.getTimePeriod(), 'allowPrePostDataDates', false),
                    periods: me.getPeriodDates(),
                    periodDateRanges: dateRanges,
                    timezone: RivalIQ.state.landscape.get('timezone')
                });

                me.listenTo(me.datePicker, 'select', me.onDatePickerSelected);

                me.$el.css('display', 'block');

                _.defer(_.bind(me._bindCloseEventListener, me));
            });
        },

        onShow: function () {
            const me = this;
            me.ui.dateInput.first().focus();
        },

        calculateMinDate: function (period) {
            const me = this;

            const minDate = _.get(me.options.dateRangeRestrictions, ['periods', period, 'min'], RivalIQ.state.landscape.getMinimumDate(period));

            return App.utils.convertToDay(minDate);
        },

        calculateMaxDate: function (period) {
            const me = this;

            const maxDate = _.get(me.options.dateRangeRestrictions, ['periods', period, 'max'], RivalIQ.state.landscape.getMaximumDate(period));

            return App.utils.convertToDay(maxDate);
        },

        calculateMinDataDate: function () {
            // NOTE translate to timezone to enforce localized post data
            const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';
            const tzDate = RivalIQ.utils.timezone.convertUtcDateToTz(RivalIQ.state.landscape.get('earliestPostData'), timezone);
            return App.utils.convertToDay(tzDate);
        },

        getTimePeriodMask: function (periodType, useFallback = true) {
            const me = this;

            const periodMask = _.get(me.options.dateRangeRestrictions, ['periods', periodType, 'mask']);
            if (_.isFinite(periodMask)) {
                return periodMask;
            }

            if (useFallback || !periodType) {
                return RivalIQ.state.account.getTimePeriodMask();
            }
        },

        getPeriodItems: function (type, period) {
            const me = this;
            const periodMask = me.getTimePeriodMask(type);

            const enabled = [];
            const disabled = [];

            let isCustomEnabled = 0;
            let customOption;

            _.forEach(timePeriodDefinitions.forPeriod(type, period).toJSON(), function (periodOption) {
                const isEnabled = periodMask & periodOption.id;
                if (periodOption.id === RivalIQ.enums.timePeriod.mainPeriodType.CUSTOM) {
                    isCustomEnabled = isEnabled;
                    customOption = periodOption;
                } else if (isEnabled) {
                    enabled.push(periodOption);
                } else {
                    disabled.push(periodOption);
                }
            });

            // to make the custom option show up last in the list
            if (isCustomEnabled) {
                enabled.push(customOption);
            } else {
                disabled.push(customOption);
            }

            return {
                enabled: enabled,
                disabled: disabled
            };
        },

        getComparePeriodItems: function (mainPeriod) {
            const me = this;
            const periodMask = me.getTimePeriodMask(periodTypeEnums.COMPARE_PERIOD, false);
            const allOptions = timePeriodDefinitions.forPeriod(periodTypeEnums.COMPARE_PERIOD, mainPeriod).toJSON();
            const maxHistoryDays = RivalIQ.state.account.get('historyLimits').historyLimitDays;
            const enabled = [];
            const disabled = [];
            _.each(allOptions, function (period) {
                if (_.isFinite(periodMask) && !(periodMask & period.id)) {
                    disabled.push(period);
                    return;
                }

                const maxHistoryDaysRequired = period.maxHistoryDaysRequired;
                const showDisabledOption = period.showDisabledOption || _.constant(true);
                if (maxHistoryDaysRequired) {
                    if (maxHistoryDays > maxHistoryDaysRequired) {
                        enabled.push(period);
                    } else if (showDisabledOption()) {
                        disabled.push(period);
                    }
                } else {
                    enabled.push(period);
                }
            });

            return {
                enabled: enabled,
                disabled: disabled
            };
        },

        getDisabledPeriods: function () {
            const me = this;
            const dateRangeRestrictions = me.options.dateRangeRestrictions;
            return _.reduce(periodTypeEnums, function (memo, periodType, key) {
                return (_.get(dateRangeRestrictions, ['periods', periodType, 'disabled']) ? memo.concat(key) : memo);
            }, []);
        },

        serializeData: function () {
            const me = this;
            const dateRangeRestrictions = me.options.dateRangeRestrictions;

            return catchAndReportErrors('serializeData', function () {
                const periods = me.getPeriodDates();
                const mainPeriod = RivalIQ.data.timePeriodDefinitions.get(periodTypeEnums.MAIN_PERIOD, me.getPeriod(periodTypeEnums.MAIN_PERIOD));
                const comparePeriod = RivalIQ.data.timePeriodDefinitions.get(periodTypeEnums.COMPARE_PERIOD, me.getPeriod(periodTypeEnums.COMPARE_PERIOD));

                const mainPeriodItems = me.getPeriodItems(periodTypeEnums.MAIN_PERIOD, mainPeriod);
                const timezone = RivalIQ.state.landscape.get('timezone');
                const comparePeriodItems = me.getComparePeriodItems(mainPeriod);
                const account = RivalIQ.state.account;
                const isTrialerWithTrialPlan = account.isTrialerWithTrialPlan();

                return {
                    timePeriod: me.getTimePeriod(),
                    mainPeriod: {
                        type: periodTypeEnums.MAIN_PERIOD,
                        selected: mainPeriod,
                        dates: periods[periodTypeEnums.MAIN_PERIOD],
                        options: mainPeriodItems.enabled,
                        disabled: mainPeriodItems.disabled,
                        unselectable: _.get(dateRangeRestrictions, ['periods', periodTypeEnums.MAIN_PERIOD, 'disabled']) === true,
                        shouldDisableInput: _.get(dateRangeRestrictions, ['periods', periodTypeEnums.MAIN_PERIOD, 'disabled'], isTrialerWithTrialPlan)
                    },
                    comparePeriod: {
                        type: periodTypeEnums.COMPARE_PERIOD,
                        selected: comparePeriod,
                        dates: periods[periodTypeEnums.COMPARE_PERIOD],
                        enabled: comparePeriodItems.enabled,
                        disabled: comparePeriodItems.disabled,
                        unselectable: _.get(dateRangeRestrictions, ['periods', periodTypeEnums.COMPARE_PERIOD, 'disabled']) === true,
                        shouldDisableInput: _.get(dateRangeRestrictions, ['periods', periodTypeEnums.COMPARE_PERIOD, 'disabled'], isTrialerWithTrialPlan)
                    },
                    dataDisabledPeriods: me.getDisabledPeriods().join('|'),
                    disableMsg: account.isTrialing() ? 'Unavailable in Trial' : _.get(dateRangeRestrictions, ['messages', 'periodDisabled'], ''),
                    timezoneStr: RivalIQ.utils.timezone.getDisplayName(timezone)
                };
            });
        },

        templateHelpers: function () {
            const me = this;
            return {
                withoutCustom: function (periods) {
                    return _.reject(periods, function (period) {
                        return RivalIQ.enums.timePeriod.type.CUSTOM === period.timePeriodId;
                    });
                },
                formatDate: function (date) {
                    return date.format(me.localeLongDateFormat);
                }
            };
        },

        getTimePeriodFromSelection: function (periodType, index, date) {
            const me = this;

            const defId = parseInt(me.$(`select[data-period-type=${periodType}]`).val());
            const period = RivalIQ.data.timePeriodDefinitions.get(periodType, defId);
            if (period && period.canEditDates()) {
                return RivalIQ.utils.timePeriod.setPeriodDate(me.getTimePeriod(), periodType, index, date);
            }

            let currTimePeriod = RivalIQ.utils.timePeriod.setPeriod(me.getTimePeriod(), periodTypeEnums.MAIN_PERIOD, RivalIQ.enums.timePeriod.mainPeriodType.CUSTOM);
            // set main to Custom when compare is modified
            if (periodType === periodTypeEnums.COMPARE_PERIOD) {
                currTimePeriod = RivalIQ.utils.timePeriod.setPeriod(currTimePeriod, periodTypeEnums.COMPARE_PERIOD, RivalIQ.enums.timePeriod.comparePeriodType.CUSTOM);
                RivalIQ.utils.timePeriod.setPeriodDate(currTimePeriod, periodTypeEnums.MAIN_PERIOD, MAIN_PERIOD_INDEX);
            }

            return RivalIQ.utils.timePeriod.setPeriodDate(currTimePeriod, periodType, index, date);
        },

        onDatePickerSelected: function (periodType, index, date, preventFocusSwitch, cursorIndex) {
            const me = this;

            if (_.isUndefined(index)) {
                index = 0;
            }

            catchAndReportErrors('onDatePickerSelected', function () {
                const timePeriod = me.getTimePeriodFromSelection(periodType, index, date);
                me.model.set({
                    timePeriod: timePeriod
                });

                // NOTE: if the selected dates overlap, we shift them. In this case we need to reset the date picker.
                me.updateDatePicker();
                me.updatePeriodSelectorAndInputs(periodType, index, preventFocusSwitch);

                const inputIndex = preventFocusSwitch ? index : index + 1;
                me.setInputFocus(periodType, inputIndex % 2, cursorIndex);

                me.validateDateRange();
            });
        },

        setInputFocus: function (periodType, index, targetSelection) {
            const me = this;

            me.ui.dateInput.each(function (i, el) {
                if ($(el).data('periodType') === periodType && $(el).data('index') === index) {
                    const target = $(el);
                    if (!target.is('focus')) {
                        target.focus();
                    }

                    if (targetSelection) {
                        // update cursor position
                        target[0].setSelectionRange(targetSelection, targetSelection);
                    }
                }
            });
        },

        onMobilePeriodChange: function (e) {
            const me = this;
            const defId = Number($(e.currentTarget).data('value'));
            const timePeriod = RivalIQ.utils.timePeriod.setPeriod(me.getTimePeriod(), periodTypeEnums.MAIN_PERIOD, defId);
            const comparePeriodId = _.get(timePeriod, ['periods', 1]);
            const mainPeriodId = _.get(timePeriod, ['periods', 2]);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2MobileApply, {
                comparePeriodId: comparePeriodId,
                mainPeriodId: mainPeriodId
            });

            me.model.set({
                timePeriod: timePeriod
            });
            me.save();
        },

        onDateInputFocus: function (e) {
            const me = this;
            const $el = $(e.currentTarget);

            const periodType = $el.data('periodType');
            const index = $el.data('index');

            me.datePicker.setField(periodType, index, $el[0]);
        },

        onDateInputFocusout: function (e) {
            const me = this;
            const $el = $(e.currentTarget);

            if (!$el.parent().hasClass('has-error')) {
                const dateInput = $el.val();
                $el.val(moment(dateInput, me.localeLongDateFormat).format(me.localeLongDateFormat));
            }
        },

        onPeriodTypeChange: function (e) {
            const me = this;

            return catchAndReportErrors('onPeriodTypeChange', function () {
                const periodType = $(e.currentTarget).data('periodType');
                const index = $(e.currentTarget).data('index') || 0;
                const defId = Number($(e.currentTarget).val());
                const period = RivalIQ.data.timePeriodDefinitions.get(periodType, defId);
                const periodCanEditDates = period?.canEditDates();
                let timePeriod = RivalIQ.utils.timePeriod.setPeriod(me.getTimePeriod(), periodType, defId);
                if (periodCanEditDates) {
                    // setPeriodDate will adjust dates if there is an overlap
                    timePeriod = RivalIQ.utils.timePeriod.setPeriodDate(timePeriod, periodType, index);
                }

                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2PeriodSelected, {
                    periodType: periodType,
                    periodId: defId
                });

                me.model.set({
                    timePeriod: timePeriod
                });
                me.updateDatePicker();
                me.updatePeriodSelectorAndInputs(periodType, index);

                me.validateAllDateInputs();

                if (periodCanEditDates) {
                    me.setInputFocus(periodType, 0);
                } else if (customPeriodTypesByPeriod[periodType] !== defId) {
                    // NOTE if we are switching the compare period from custom to previous period, move the
                    // focus back to the main period input; see #19905
                    me.setInputFocus(periodTypeEnums.MAIN_PERIOD, 0);
                }

                me.datePicker.gotoMainEnd();
            });
        },

        onDateInputChange: function (e) {
            const me = this;
            me.updateDateInput(e, false);
        },

        validateAllDateInputs: function () {
            const me = this;

            me.ui.dateForm.each(function (i, el) {
                const validDate = me.validateDateInput($(el).find('.date-input'));
                if (validDate) {
                    $(el).removeClass('has-error');
                }
            });
        },

        validateDateInput: function ($el, correctInvalidPreviousYearError) {
            const me = this;

            const rawDate = $el.val();
            const sanitizedDate = App.utils.sanitizeDateInput(rawDate);
            const $formGroup = $el.parent('.date-form');
            const inputPeriodType = $el.data('periodType');
            const inputIndex = $el.data('index');
            const dateIsValid = me.validateDate($formGroup, inputPeriodType, inputIndex, sanitizedDate, correctInvalidPreviousYearError);
            if (dateIsValid) {
                return moment(rawDate, me.localeLongDateFormat);
            }
        },

        updateDateInput: function (e, ignoreFocus) {
            const me = this;

            const $el = $(e.target);
            const date = me.validateDateInput($el, true);

            if (date) {
                const maxDate = me.calculateMaxDate(periodTypeEnums.MAIN_PERIOD);
                const inputMaxDate = new Date(maxDate.getTime());
                const inputPeriodType = $el.data('periodType');
                const index = $el.data('index');

                // maxDate for the compare period is one less than the main period
                if (inputPeriodType === periodTypeEnums.COMPARE_PERIOD) {
                    inputMaxDate.setDate(inputMaxDate.getDate() - 1);
                }

                const cursorIndex = e.target.selectionStart;
                me.datePicker.setDate(date);
                me.onDatePickerSelected(inputPeriodType, index, date, true, cursorIndex);
            }
        },

        validateDate: function ($formGroup, inputPeriodType, inputIndex, date, correctInvalidPreviousYearError) {
            const me = this;

            const maxDate = me.calculateMaxDate(periodTypeEnums.MAIN_PERIOD);
            const inputMaxDate = new Date(maxDate.getTime());

            // momentjs will auto fill in the year to 2020 if not provided
            // we validate the raw date on input, the auto-filled date on tab or click away
            let invalidRawDate = false;
            if (!moment.isMoment(date)) {
                // date doesn't have a day, month, year section
                // if the year is YYYY format
                const dateComponents = date.split('/');
                if (dateComponents.length < 3) {
                    invalidRawDate = true;
                } else if (me.isYearFirstFormat()) {
                    if (!(dateComponents[0].length === 4)) {
                        invalidRawDate = true;
                    }
                } else {
                    if (!(dateComponents[2].length === 4)) {
                        invalidRawDate = true;
                    }
                }

                // valid date, set to moment for rest of validation process
                if (!invalidRawDate) {
                    date = moment(date, me.localeLongDateFormat);
                }
            }

            if (invalidRawDate || !date.isValid()) {
                $formGroup.addClass('has-error');
                const formatOptions = me.localizeDatePickerFormatOptions();
                me.showWarning(RivalIQ.str('date_picker_invalid_date_format', formatOptions), true);
                return false;
            } else if (date.isBefore(me.calculateMinDate(inputPeriodType))) {
                $formGroup.addClass('has-error');
                const warningMessage = _.get(me.options.dateRangeRestrictions, ['messages', 'dateOutOfRangeError'], RivalIQ.strings.date_picker_invalid_date_too_old);
                me.showWarning(warningMessage);
                return false;
            } else if (date.isAfter(maxDate)) {
                $formGroup.addClass('has-error');
                let warningMessage = _.get(me.options.dateRangeRestrictions, ['messages', 'dateOutOfRangeError']);
                if (date.isAfter(moment.utc()) || !warningMessage) {
                    warningMessage = RivalIQ.strings.date_picker_invalid_date_future;
                }
                me.showWarning(warningMessage);
                return false;
            } else if (date.isAfter(inputMaxDate)) {
                $formGroup.addClass('has-error');
                me.showWarning(RivalIQ.strings.date_picker_invalid_date_today);
                return false;
            } else {
                const timePeriod = me.getTimePeriod();
                let mainPeriodStart = timePeriod.dates[periodTypeEnums.MAIN_PERIOD][0];
                let mainPeriodEnd = timePeriod.dates[periodTypeEnums.MAIN_PERIOD][1];
                // if we're validating a main period input, use date from input to determine diff
                if (inputPeriodType === periodTypeEnums.MAIN_PERIOD) {
                    if (inputIndex === 0) {
                        mainPeriodStart = date;
                    } else {
                        mainPeriodEnd = date;
                    }
                }

                if (mainPeriodEnd.diff(mainPeriodStart, 'year') >= 1 && timePeriod.periods[periodTypeEnums.COMPARE_PERIOD] === RivalIQ.enums.timePeriod.comparePeriodType.PREVIOUS_YEAR) {
                    // They have "Previous Year" selected for their compare period, but the main period is more than a full year long.

                    // depending on what they just edited we do different things. If they've just edited a main period date, we'll update the previous period to custom for them. Otherwise,
                    // we'll show an error.
                    if (correctInvalidPreviousYearError) {
                        timePeriod.periods[periodTypeEnums.COMPARE_PERIOD] = RivalIQ.enums.timePeriod.comparePeriodType.PREVIOUS_PERIOD;
                    } else {
                        $formGroup.addClass('has-error');
                        me.showWarning(RivalIQ.strings.date_picker_invalid_date_incompatible_with_year_comparison);
                        return false;
                    }
                }
            }

            return true;
        },

        isYearFirstFormat: function () {
            const me = this;
            // NOTE some locales use specific delimiters ('/' vs '.'). Check that the first char is a Y.
            return _.head(me.localeLongDateFormat) === 'Y';
        },

        isDayFirstFormat: function () {
            const me = this;
            return _.head(me.localeLongDateFormat) === 'D';
        },

        monthFirstFormats: [
            'MM/DD/YYYY',
            'M/D/YYYY',
            'MMDDYYYY'
        ],

        localizeDatePickerFormatOptions: function () {
            const me = this;

            let formatFn;
            if (me.isDayFirstFormat()) {
                // Day first format: switch the day and month in the format string
                formatFn = function (format) {
                    return format.replace(/M/g, 'A').replace(/D/g, 'M').replace(/A/g, 'D');
                };
            } else if (me.isYearFirstFormat()) {
                // Year first format (Japanese)
                formatFn = function (format) {
                    return `YYYY/${format.slice(0, -5)}`;
                };
            }
            return _.map(me.monthFirstFormats, function (format) {
                if (formatFn) {
                    format = formatFn(format);
                }
                return `<li>${format}</li>`;
            }).join('');
        },

        updatePeriodSelectorAndInputs: function (changedPeriodType, changedIndex, validateRawDate) {
            const me = this;

            const periodDates = me.getPeriodDates();

            me.ui.dateInput.each(function (i, el) {
                const periodType = $(el).data('periodType');
                const index = $(el).data('index');
                let dateValue;
                // keep the changed raw date for user validation
                if (changedPeriodType === periodType && changedIndex === index && validateRawDate) {
                    dateValue = $(el).val();
                } else {
                    dateValue = periodDates[periodType][index].format(me.localeLongDateFormat);
                }

                $(el).val(dateValue);
            });

            const mainPeriod = RivalIQ.data.timePeriodDefinitions.get(periodTypeEnums.MAIN_PERIOD, me.getPeriod(periodTypeEnums.MAIN_PERIOD));
            me.ui.periodSelector.each(function (e, el) {
                const selectedPeriodType = $(el).data('periodType');

                const sortBy = selectedPeriodType === periodTypeEnums.COMPARE_PERIOD ? 'name' : '';
                const options = timePeriodDefinitions.forPeriod(selectedPeriodType, mainPeriod, sortBy);

                const customOption = _.remove(options.models, function (option) {
                    return option.get('id') === (selectedPeriodType === periodTypeEnums.COMPARE_PERIOD ? RivalIQ.enums.timePeriod.comparePeriodType.CUSTOM : RivalIQ.enums.timePeriod.mainPeriodType.CUSTOM);
                });
                if (customOption.length) {
                    options.models.push(customOption[0]);
                }

                el.innerHTML = renderPeriodOptions(me.getTimePeriodMask(selectedPeriodType), me.getPeriod(selectedPeriodType), options);
            });

            me.hideWarning();
        },

        updateDatePicker: function () {
            const me = this;

            me.datePicker.setPeriods(!me.calendarEditable(), me.getPeriodDates());
        },

        validateDateRange: function () {
            const me = this;
            const periods = me.getPeriodDates();
            const mainPeriod = periods[periodTypeEnums.MAIN_PERIOD];
            const comparePeriod = periods[periodTypeEnums.COMPARE_PERIOD];

            const activeCompanySet = RivalIQ.state.view.get('companySetDescriptor');
            const companiesInCurrentTag = RivalIQ.state.landscape.getCompaniesByCompanySet(activeCompanySet).length;
            const mainStart = moment.utc(mainPeriod[0]).startOf('day');
            const mainEnd = moment.utc(mainPeriod[1]).endOf('day');
            const compareStart = moment.utc(comparePeriod[0]).startOf('day');
            const compareEnd = moment.utc(comparePeriod[1]).endOf('day');

            // Calculations are carried over from the server : dataServicesHelpers.validateTimePeriod
            const mainPeriodDays = mainEnd.diff(mainStart, 'days') + 1;
            const comparePeriodDays = compareEnd.diff(compareStart, 'days') + 1;
            const maxCompanyDaysOfData = RivalIQ.state.account.get('historyLimits').maxCompanyDaysOfData;

            // Check the following:
            // companies_in_current_tag * (days_in_main + days_in_compare) < account.historyLimits.maxCompanyDaysOfData
            if (companiesInCurrentTag * (mainPeriodDays + comparePeriodDays) >= maxCompanyDaysOfData) {
                me.showWarning(RivalIQ.strings.date_picker_too_much_data);
            } else {
                me.validateAllDateInputs();
            }
        },

        // NOTE the calendar is always editable when custom periods are now (see #16844)
        calendarEditable: function () {
            const me = this;
            const periodMask = me.getTimePeriodMask();
            return (periodMask & RivalIQ.enums.timePeriod.mainPeriodType.CUSTOM);
        },

        getTimePeriod: function () {
            const me = this;
            return me.model.get('timePeriod');
        },

        getPeriodDates: function () {
            const me = this;
            return me.getTimePeriod().dates;
        },

        getPeriod: function (periodType) {
            const me = this;
            return me.getTimePeriod().periods[periodType];
        },

        _bindCloseEventListener: function () {
            const me = this;

            const hideFn = function (e) {
                if (!$(e.target).parents('.x-datepicker').length) {
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2ClickAway);
                    me.close();
                }
            };

            $('body').on('click', hideFn);
            me.listenTo(me, 'destroy', function () {
                $('body').off('click', hideFn);
            });
        }
    });

}, window.moment);
